import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'portal.views.unsubscribeError.title',
    defaultMessage: 'Unsubscribe Failed',
    description: 'Page title for unsubscribe error',
  },
  heroTitle: {
    id: 'portal.views.unsubscribeError.hero.title',
    defaultMessage: 'Oops!',
    description: 'Hero title for unsubscribe error page',
  },
  mainMessage: {
    id: 'portal.views.unsubscribeError.message',
    defaultMessage: 'We were unable to process your unsubscribe request.',
    description: 'Main error message',
  },
  additionalInfo: {
    id: 'portal.views.unsubscribeError.additionalInfo',
    defaultMessage: 'This may have happened because the link has expired or was already used. Please try again or contact our support team for assistance.',
    description: 'Additional information about the error',
  },
  contactSupport: {
    id: 'portal.views.unsubscribeError.contactSupport',
    defaultMessage: 'Contact Support',
    description: 'Link text to contact support',
  },
  returnHome: {
    id: 'portal.views.unsubscribeError.returnHome',
    defaultMessage: 'Return to Home',
    description: 'Link text to return to home page',
  },
  bgAlt: {
    id: 'portal.views.unsubscribeError.bg.alt',
    defaultMessage: 'Unsubscribe error background',
    description: 'Background image alt text',
  },
});

export default messages;
